import { render, staticRenderFns } from "./_CustomPagination.vue?vue&type=template&id=03c6a240&scoped=true&"
import script from "./_CustomPagination.vue?vue&type=script&lang=js&"
export * from "./_CustomPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c6a240",
  null
  
)

export default component.exports